module.exports = __webpack_public_path__ + "static/img/funny_06.3096d1fb.jpg";